import React from 'react'

const ColoredBadge = ({text,bgColor,textColor,className=''}) => {
  return (
    <div className={`px-2 py-[2px] ${bgColor} ${textColor} ${className}`}>
      <p className={`text-[10px]`}>{text}</p>   
    </div>
  )
}

export default ColoredBadge